document.addEventListener('DOMContentLoaded', function() {

	document.querySelectorAll('select').forEach(function(select) {
		select.addEventListener('change', function() {
			if (this.value === '') {
				this.classList.add('empty');
			} else {
				this.classList.remove('empty');
			}
		});
		select.dispatchEvent(new Event('change'));
	});

	const toTopBtn = document.getElementById('toTopBtn');

	function updateToTopVisibility() {
		if (window.scrollY > 600) {
			toTopBtn.classList.add('visible');
		} else {
			toTopBtn.classList.remove('visible');
		}
	}

	window.addEventListener('scroll', updateToTopVisibility);
	window.addEventListener('resize', updateToTopVisibility);

	toTopBtn.addEventListener('click', function() {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	document.querySelectorAll('[data-link]').forEach(function(el) {
		el.addEventListener('click', function() {
			window.location = this.dataset.link;
		});
	});
});